import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

export abstract class _GameNameHorizontalBase extends BaseCssVarValue {
  abstract cssType: 'default' | 'small' | 'larger'
  /** 游戏名称水平布局的内边距 */
  ['--game-name-horizontal-padding']?: string;
  /** 左边logo的宽度 */
  ['--left-logo-width']?: string;
  /** 左边logo的高度 */
  ['--left-logo-height']?: string;
  /** 右边名称的左外边距 */
  ['--right-name-margin-left']?: string;
  /** 右边名称的字号 */
  ['--right-name-font-size']?: string
}
